var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcWorldChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3016_5288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.57254 9.7907H1V6.79941H2.57254L14.6287 3.30957V13.2805L2.57254 9.7907ZM7.29015 11.1866L7.1329 11.6852C6.87081 12.5327 5.92729 12.9814 5.0886 12.7321C4.19749 12.4829 3.72573 11.5855 3.98782 10.7878L4.14508 10.2892",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3016_5288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.6287,
    height: 9.97097,
    fill: "white",
    transform: "translate(1 3.30957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWorldChat);
export default __webpack_public_path__ + "static/media/ic_world_chat.f040431479a832a99661516d23343f66.svg";
export { ForwardRef as ReactComponent };